import React from 'react';
import Header from '../components/Frontend/Header';
import Footer from '../components/Frontend/Footer';
import FameWallPte from '../components/Frontend/FameWallPte';
import Testimonial from '../components/Frontend/Testimonial';
import WhyLove from '../components/Frontend/WhyLove';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import { Link} from 'react-router-dom';
import VideoTuts from "../components/Frontend/VideoTuts";

class Pte extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
    };
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

    componentDidMount() {
        ReactGA.initialize('UA-157984080-1');
        ReactGA.pageview(window.location.pathname + window.location.search);
        ReactPixel.init('2474090032742391');
        ReactPixel.init('197333187452630');
        ReactPixel.pageView();
    }
 render(){
    const customslider = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
  };
    return (
    <React.Fragment>
    <Helmet>
        <title>Top PTE Training Institute In Australia | Language Academy</title>        
        <meta name="description" content="Enroll in Language Academy's PTE online training classes for flexible, effective preparation. Access expert coaching and resources from anywhere." />
    </Helmet>
    <Header />
    <div className="hero-section mt-80">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 col-md-8">
                <div className="hero-content">
                  <h1 className="primary-heading mfw-600">
                      Start your PTE Exam <br className="d-none d-lg-block" />
                      Preparation online <br className="d-none d-lg-block" />
                    with us and Achieve <br className="d-none d-lg-block" />
                      your Desired Score
                  </h1>
                  <p className="sub-heading bold-sub-heading">
                  Begin your journey towards a better tomorrow
                  <br className="d-none d-md-block" />                 
                  with the best Online PTE preparation Classes
                  </p>
                  <div className="text-center text-md-start">
                  <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-4">
                <div className="hero-img-wrapper">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/bannerImg.png"
                    alt="LA"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pte-content-section wrsl-content-section poc-section pb-0">
          <div className="circle-section">
            <div className="container pte-container">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="primary-heading text-center">PTE Training <br className="d-block" /> in Sydney with <br className="d-block" /> <span className="wpl-badge pte-naati-badge text-white">Language Academy</span></h2>
                  <div className="position-relative">
                    <ul className="m-0">
                      <li>                       
                        Are you working full-time and got time for PTE exam training only on weekends or at night?
                      </li>
                      <li>                       
                        Having any issues with the hectic travelling for the PTE exam preparation?
                      </li>
                      <li>                        
                        Looking for the best instructor for your PTE preparation online but cannot meet them due to lack of limited resources?
                      </li>
                      <li>                      
                        Are you a time-poor person and wants to get the appropriate time for the PTE exam coaching?
                      </li>
                    </ul>                   
                  </div>
                  <div className="pte-bottom-content">
                    <div>
                      <div onClick={this.handleClick} className="pte-bottom-header d-flex justify-content-center align-items-center">
                        <h3 className="m-0">
                          <a href="javascript:void(0)" className="text-decoration-none">
                            Read More
                          </a>
                        </h3> 
                        <img src="/images/web-new-images/icons/bottom-arrow-01.png" alt="LA" />      
                      </div>
                      <ul className={`hide-content ${this.state.isActive ? "active" : ""}`}> 
                        <li>                       
                        If you are ticking the status yes for any of these above problems it means you are here for PTE online training. We are providing the world-class PTE online coaching to the aspirants so they can achieve their dreams to study abroad. Our PTE online course material is designed in such a way that students can easily learn the concept from the basic level.
                        </li>
                        <li>                      
                        <span>
                        If you want to Enrol yourself in the PTE online classes or wants to ask any query related to PTE exam preparation online then contact us at <a href="mailto:info@languageacademy.com.au" target="blank">info@languageacademy.com.au</a>
                        </span>
                        </li>
                    </ul>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                <Link to="/auth/register" className="primary-btn">REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="LA" /></Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <FameWallPte />
        <Testimonial />
        <div className="exam-pattern-section pte-exam-pattern pcs-exam-pattern pt-0">
              <div className="container">
                <div className="row">
                <h2 className="primary-heading text-center">
                Why People Love <br className='d-block' /><span className="wpl-badge pte-naati-badge text-white">Language Academy</span></h2> 
                <p className='sub-heading text-center'>
                We provide the top-rated PTE training to the candidates
                <br className='d-none d-lg-block' />
                to make their career journey smooth
                </p>
                  <div className="pattern-cards-outer mb-0">  
                  <div className="exam-pattern-cards position-relative">                
                    <Slider {...customslider}>                       
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Experienced Trainer</h3>
                        <p>
                        We have Pearson certified faculty members...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Highest Success Rate</h3>
                        <p>
                        Students will get a sure-shot success with the high...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Free Books</h3>
                        <p>
                        Our PTE / NAATI training institute provides free books...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Latest Resources</h3>
                        <p>
                        Making use of the latest technology, we provide...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Online Support</h3>
                        <p>
                        Our experts are always there to help the students through...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">3500 + Questions to Practice</h3>
                        <p>
                        We give the students various exercises and practice
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Discussion Sessions</h3>
                        <p>
                        During the discussion sessions, Our experienced team...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Affordable Fees</h3>
                        <p>
                        We offer the best PTE and NAATI coaching classNamees...
                        </p>                      
                      </div>
                      <div className="exam-pattern-card">
                        <div className="img-wrapper">
                          <img
                            src="/images/web-new-images/icons/speaking-icon.svg"
                            alt="LA"
                          />
                        </div>
                        <h3 className="card-title">Real Time Test Environment</h3>
                        <p>
                        We provide several mock tests for reading, listening...
                        </p>                      
                      </div>                         
                    </Slider>
                  </div>
                  <div className="text-center">
                    <Link to="/auth/register" className="dark-border primary-btn">
                    REGISTER NOW <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" />
                    </Link>
                  </div>
                  </div>
                </div>
              </div>
        </div> 
        < VideoTuts />
        <div className="faq-section mt-faq">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>

              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      What is the recommended number of PTE mock tests that I should undertake?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    It is recommended to take three complete PTE mock tests.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What is the PTE requirement for canada?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    The minimum PTE score for Bachelor's programs, Advanced Diplomas, and Post Graduate Programs is 60, with a minimum band score of 53. Students with an overall score of 56 and each band score of at least 51 have also been granted study permits.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      What is the duration of a full-length PTE mock test?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                    Around 2 hours. Students can attempt the test in one go or by taking short breaks.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    	<Footer />
    </React.Fragment>);
    }
}
export default Pte;